import React, { useMemo } from "react";
import { Space, Avatar, Typography, Spin, Breadcrumb } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
const antIcon = <LoadingOutlined style={{ fontSize: 20, color: "white" }} spin />;
const { Text } = Typography;

export const HeaderTitle = ({ title, subtitle, icon, loading }) => {
  let items = useMemo(() => {
    let items = [];
    if (Array.isArray(title)) {
      for (let i of title) {
        items?.push({
          title: (
            <Text level={4} strong style={{ fontSize: 20 }}>
              {i}
            </Text>
          ),
        });
      }
    } else {
      items?.push({
        title: (
          <Text level={4} strong style={{ fontSize: 20 }}>
            {title}
          </Text>
        ),
      });
    }

    return items;
  }, [title]);

  return (
    <div>
      <Space size={20} wrap className="content-header-profile">
        <Space size={20}>
          <Avatar
            size={60}
            shape="square"
            icon={loading ? <Spin indicator={antIcon} /> : icon}
            style={{ backgroundColor: "#60b565" }}
          />
          <Space direction="vertical" size={0}>
            <Breadcrumb
              separator={<div style={{ display: "flex", alignItems: "center", height: "100%" }}>/</div>}
              items={items}
            />
            {<Text>{!subtitle || loading ? "-" : subtitle}</Text>}
          </Space>
        </Space>
      </Space>
    </div>
  );
};
